import { useFilterOptionsClient } from "@domains/reviews/client/api/filterOptionsQuery.ts";
import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const NO_LABELS = new Map<string, string>();

export function useManagerLabels(memberIds: string[]): Map<string, string> {
    const client = useFilterOptionsClient();
    const ids = useMemo(() => [...new Set(memberIds)].toSorted(), [memberIds]);

    const options = client.searchReportingManagers.queryOptions({ input: { restrictToMemberIds: ids, pageSize: ids.length || 1 } });

    const { data } = useQuery(
        createQueryOptions(options, {
            enabled: ids.length > 0,
            placeholderData: keepPreviousData,
            throwOnError: false
        })
    );

    return useMemo(() => (data ? new Map(data.items.map(manager => [manager.id, manager.displayName])) : NO_LABELS), [data]);
}
